module.exports = __webpack_public_path__ + "static/media/item_6_23_comp.251e86a0.png";